import { render, staticRenderFns } from "./SimpleMessageEditor.vue?vue&type=template&id=6b69b7cc&scoped=true"
import script from "./SimpleMessageEditor.vue?vue&type=script&lang=js"
export * from "./SimpleMessageEditor.vue?vue&type=script&lang=js"
import style0 from "./SimpleMessageEditor.vue?vue&type=style&index=0&id=6b69b7cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b69b7cc",
  null
  
)

export default component.exports